import { ApiParameter, get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";

const baseUrl = "/api/v1";


export interface ProductCategoriesParameter {
    productIds: string[];
    type: string;
}

export interface ProductCategoriesModel {
    id: string;
    erpNumber: string;
    categories: {
        item_category: string;
        item_category2: string;
        item_category3: string;
    };
    categoriesIds: {
        item_category: string;
        item_category2: string;
        item_category3: string;
    };
    brandName: string | null;
    customProperties: Record<string, unknown>;
    attributes: {
        [key: string]: string;
    };
}


export async function getProductCategories(
    params: ProductCategoriesParameter,
): Promise<ServiceResult<ProductCategoriesModel[]>> {
    try {
        const result = await post<{ productProperties: ProductCategoriesModel[] }>(
            `${baseUrl}/productproperties`,
            params as any,
        );

        return {
            result: result.productProperties,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

interface SystemListItem {
    description: string;
    name: string;
}

export async function getSystemList(): Promise<ServiceResult<{ systemList: SystemListItem[] }>> {
    type ResponseItem = Partial<SystemListItem> & { Description?: string; Name?: string };
    const data = await get<{ List?: ResponseItem[]; list?: ResponseItem[] }>(`${baseUrl}/customlist/restrictedCharacters`);
    const systemList = data?.list ?? data?.List;
    if (!Array.isArray(systemList)) {
        return { successful: false, errorMessage: "Invalid restricted PO characters response." };
    }

    return {
        successful: true,
        result: {
            systemList: systemList.map(item => ({
                description: item.description ?? item.Description ?? "",
                name: item.name ?? item.Name ?? "",
            })),
        },
    };
}
